<template>
    <div class="currency-switcher">

    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
    
</style>